import React, { Fragment } from 'react';
import { Form, Select } from 'antd';

const Gps = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">ГЛОНАСС (ГЛОНАСС/GPS):</span>
      <Form.Item>
        {getFieldDecorator('gps')(
          <Select
            placeholder="Укажите наличие"
            className="basicInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            <Select.Option value={1} key="Да">
              Да
            </Select.Option>
            <Select.Option value={0} key="Нет">
              Нет
            </Select.Option>
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default Gps;
